import { Avatar, Button, Select } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import "./Home.scss";
import { debounce } from "lodash";
import { Loader } from "shared/components";
import { fetchArtistByName } from "radar/Service/RadarService";
import { useTranslation } from "react-i18next";

interface AddArtistCardProps {
  onAdd: (artistId: string) => void;
  blocked?: boolean;
}
const AddArtistCard: React.FC<AddArtistCardProps> = (props) => {
  const { blocked, onAdd } = props;
  const { t } = useTranslation("radar");
  const [searchMode, setSearchMode] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [artistsOptions, setArtistsOptions] = useState<any>([]);
  const [searchedArtists, setSearchedArtists] = useState([]);

  const getArtists = async (artistNameTerm: string) => {
    if (artistNameTerm.replace(/[/\\#,+()$~%.'":*?<>{}]/g, "")) {
      setLoading(true);
      setArtistsOptions([]);
      const response = await fetchArtistByName({ artistNameTerm });
      setSearchedArtists(response);
      setLoading(false);
    }
  };

  const addArtistAnndClean = (artistId: string) => {
    onAdd(artistId);
    setSearchedArtists([]);
    setArtistsOptions([]);
    setSearchMode(false);
  };

  useEffect(() => {
    setArtistsOptions(
      searchedArtists.map(
        ({ artistIdStrm, artistName, imagesSpotify }: any) => ({
          id: artistIdStrm,
          name: artistName,
          image: (imagesSpotify && imagesSpotify[2]?.url) || "",
        })
      )
    );
  }, [searchedArtists]);

  return (
    <div className="artist-card-shadow">
      <div className="artist-card add-border">
        {blocked ? (
          <h1 style={{ fontSize: 20, color: "#fff", textAlign: "center" }}>
            {t("pages.Home.blockedAdd")}
          </h1>
        ) : searchMode ? (
          <Select
            showSearch
            filterOption={false}
            suffixIcon={<SearchOutlined />}
            onSearch={debounce(getArtists, 1000)}
            onSelect={(value: any) => addArtistAnndClean(value)}
            style={{ width: "100% " }}
            notFoundContent={<Loader.NotFoundLoader loading={loading} />}
          >
            {artistsOptions.map((artist: any) => (
              <Select.Option value={artist.id} key={artist.id}>
                {artist.image && (
                  <Avatar style={{ marginRight: "6px" }} src={artist.image} />
                )}
                {artist.name}
              </Select.Option>
            ))}
          </Select>
        ) : (
          <>
            <h1 style={{ fontSize: 20, color: "#fff", textAlign: "center" }}>
              {t("pages.Home.addArtist")}
            </h1>
            <Button
              className="add-button"
              icon={<PlusOutlined style={{ fontSize: 64, color: "#5E5858" }} />}
              onClick={() => setSearchMode(true)}
              style={{}}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default AddArtistCard;
